import 'primereact/resources/primereact.css'
import 'primeicons/primeicons.css'
import 'bootstrap-icons/font/bootstrap-icons.min.css'

import './App.css';
import Router from './routes/router';
import { AuthProvider } from './context/authContext'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";


// Registrar os componentes básicos
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

function App() {

  return (
    <AuthProvider value={{ authenticated: Boolean }}>
      <ToastContainer theme='colored' />
      <Router />
    </AuthProvider>
  );
}

export default App;
